import React, { useEffect, useState } from 'react'
import { useGwGoodsTypeUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions,Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import WebGoodsTypeEdit from './WebGoodsTypeEdit';
import SonTypeList from './SonTypeList';
function WebGoodsTypeDesc(props) {
    const [info,setInfo] = useState({
        eowgt_name:''
    })
    const {data,isSuccess} = useGwGoodsTypeUpdateQuery({eowgt_id:props.eowgt_id},{skip:!props.eowgt_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({                                     
                    eowgt_ctime:data.Result.eowgt_ctime,                                       
                    eowgt_uname:data.Result.eowgt_uname,                                       
                    eowgt_riqi:data.Result.eowgt_riqi,                                                
                    eowgt_name:data.Result.eowgt_name,                                                
                    eowgt_content:data.Result.eowgt_content,                                                
                    eowgt_num:data.Result.eowgt_num,                                                 
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'edit',
            label:'名称',
            children:info.eowgt_name,
            span:3
        },
        {
            key:'first',
            label:'企业类型',
            children:<SonTypeList  
                        eowgt_id={props.eowgt_id}
                    />,
            span:3
        },
        {
            key:'7',
            label:'部门',
            children:<>{info.eowgt_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.eowgt_uname+info.eowgt_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:<WebGoodsTypeEdit eowgt_id={props.eowgt_id}/>,
        },    
    ]
    return (
        <>
            {info.eowgt_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='行业'
                                        num={props.eowgt_id}                    
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default WebGoodsTypeDesc